/**
 * Cliente HTTP de «Campañas»: un wrapper tipado sobre `req()` de campana-nueva, como Público. Nunca se manda el comercio
 * (sale del token).
 */

import { req } from "../campana-nueva/api";
import { qs } from "../wa-oficial/api";
import type { Resp } from "../wa-oficial/api";
import type { Calendario, FiltrosCampanas, ListaCampanas } from "./types";

export const qsFiltros = (f: FiltrosCampanas = {}) =>
  qs({
    mundo: f.mundo,
    estado: f.estado,
    canal: f.canal,
    periodo: f.periodo && f.periodo !== "todo" ? f.periodo : undefined,
    q: f.q?.trim() || undefined,
    pagina: f.pagina && f.pagina > 1 ? f.pagina : undefined,
  });

export const campanasApi = {
  listar: (f?: FiltrosCampanas): Promise<Resp<ListaCampanas>> => req("GET", `/activa/campanas${qsFiltros(f)}`),
  /** Lo que sale entre dos instantes (el primer día de la vista y el que sigue al último), con la regla de fatiga. */
  calendario: (r: { desde: Date; hasta: Date }): Promise<Resp<Calendario>> =>
    req("GET", `/activa/campanas/calendario${qs({ desde: r.desde.toISOString(), hasta: r.hasta.toISOString() })}`),
};
